import axios from "axios";
import { apiURI } from "..";

export async function logoutUser(history) {
	// Server-side session invalidation is best-effort. The client MUST always
	// clear its auth state and redirect afterwards — otherwise an invalid/expired
	// token (the very case that triggers logout) leaves the user stranded on a page
	// whose API calls keep 401/403-ing, because the logout request itself fails and
	// the cleanup that used to live only in .then() never runs.
	try {
		await axios.post(`${apiURI}/auth/logout`);
	} catch (error) {
		console.log(
			"logout API call failed; clearing client session anyway",
			error?.response?.data
		);
	} finally {
		localStorage.clear();
		dispatchEvent(new Event("storage"));
		// delete token from Auth header
		delete axios.defaults.headers.common["Authorization"];
		history("/login");
	}
}
